import { gql } from "graphql-tag"

const typeCustomType = gql`
  type Mutation {
    addCustomAdmUserType: Boolean
    addCustomCustomLineItemType: Boolean
    addCustomerAddressCustomType: Boolean
    addCustomerCustomType: Boolean
    addCustomFieldToCustomLineItemType: Boolean
    addCustomCartType: Boolean
    editCustomCartType: Boolean
  }
`

export { typeCustomType }

export default typeCustomType
